// extracted by mini-css-extract-plugin
module.exports = {"interestText":"style_interestText__VB2kL","downPaymentText":"style_downPaymentText__4ad8N","headingText":"style_headingText__km530"};